module.exports = __webpack_public_path__ + "static/media/209-Patientenakte_ID_28.a99812b1.mp3";